import {Component, OnInit, OnDestroy, Inject, Input, Output, EventEmitter} from '@angular/core';
import {Location} from '@angular/common';
import {NavigationEnd, Router} from '@angular/router';
import {MSAL_GUARD_CONFIG, MsalGuardConfiguration, MsalService} from '@azure/msal-angular';
import {RedirectRequest} from '@azure/msal-browser';
import {Observable, Subject, filter, map, tap, take } from 'rxjs';
import {environment} from 'src/environments/environment';
import {TooltipPosition} from '@angular/material/tooltip';
import {FormControl} from '@angular/forms';
import {MatMenuListItem} from '../model/mat-menu-list-item';
import {FilterService} from 'src/app/shared/service/filter/filter.service';
import {ModalService} from 'src/app/shared/service/modal/modal.service';
import {FilterModalComponent, FilterResult} from 'src/app/shared/modals/filter-modal/filter-modal.component';
import {DateService} from 'src/app/shared/service/date/date.service';
import {ApplicationConstants} from 'src/app/shared/constants/application.constants';
import {AutoUnsubscribe} from '../../../infrastructure/decorators/auto-unsubscribe.decorator';
import {AzureAuthService, UserAzureProfileDetails} from '../../../infrastructure/services/azure-auth.service';
import {VccDailySummaryReportFilterModalComponent} from 'src/app/shared/modals/vcc-daily-summary-reports-filter-modal/vcc-daily-summary-reports-filter-modal.component';
import {VccDailySummaryReportFilterResult} from 'src/app/shared/model/vcc-daily-summary-report-filter-result';
import {FinanceReportsFilterModalComponent} from 'src/app/shared/modals/finance-reports-filter-modal/finance-reports-filter-modal.component';
import {FinanceReportFilterResult} from 'src/app/shared/model/finance-report-filter-result';
import {AdxVccService} from 'src/app/finance-resource/service/adx-vcc.service';
import {AdxVccFilterComponent} from 'src/app/finance-resource/component/adx-vcc-filter/adx-vcc-filter.component';
import {AdxVccFilter} from 'src/app/finance-resource/model/adx-data';
import {FmsVccService} from '../../finance-resource/service/fms-vcc.service';
import {FmsVccFilterResult} from '../../finance-resource/model/fms-vcc-filter-result';
import {FmsVccFilterModalComponent} from '../../fms-vcc/components/fms-vcc-filter-modal/fms-vcc-filter-modal.component';
import {ChartsVccService} from '../../dashboard/service/charts-vcc.service';
import {VccChartFilterResult} from '../../dashboard/model/funding-vcc-chart-filter';
import {VccChartFilterModalComponent} from '../../dashboard/layout/vcc/components/vcc-chart-filter-modal/vcc-chart-filter-modal.component';
import {ClientFilterResult} from 'src/app/client/component/filter-modal/client-filter-result';
import {ClientService} from 'src/app/client/service/client.service';
import {Client, ClientData} from 'src/app/client/service/client.model';
import {AgentFilterResult} from 'src/app/agent/component/filter-modal/agent-filter-result';
import {AgentService} from 'src/app/agent/component/service/agent.service';
import {Agent, AgentData} from 'src/app/agent/component/service/agent.model';
import moment from 'moment';
import {HsProcessingFilterComponent} from '../../trx-team-resource/components/hs-processing-filter/hs-processing-filter.component';
import {HsProcessingService} from '../../trx-team-resource/services/hs-processing.service';
import {HsProcessingFilter} from '../../trx-team-resource/models/hs-process.component';
import {AdxPaymentService} from 'src/app/payments/service/adx-payment.service';
import {GeneralLedgerService} from 'src/app/general-ledger/service/general-ledger.service';
import {GlClosePeriodFilterComponent} from 'src/app/general-ledger/components/close-period-filter/close-period-filter.component';
import {ClosePeriodFilter} from 'src/app/general-ledger/model/general-ledger';
import {PaymentReconciliationFilterComponent} from 'src/app/payments/components/payments-reconciliation-filter/payments-reconciliation-filter.component';
import {PaymentReconciliationFilter} from 'src/app/payments/models/client-reconciliation';
import {BraintreeMatchedVccFilter} from 'src/app/finance-resource/model/braintree-matching-vcc';
import {BraintreeMatchingVccFilterComponent} from 'src/app/finance-resource/component/braintree-matching-vcc-filter/braintree-matching-vcc-filter.component';
import {BraintreeMatchingVccService} from 'src/app/finance-resource/service/braintree-matching-vcc.service';
import {AirMatchingReportFilterComponent} from 'src/app/finance-resource/component/air-matching-report-filter/air-matching-report-filter.component';
import {AirMatchingReportService} from 'src/app/finance-resource/service/air-matching-report.service';
import {NavService} from 'src/app/nav/upload/service/nav.service';
import {FinanceFilterModalService} from "../../dashboard-finance/service/finance-filter-modal.service";
import {AdminPanelFilterService} from "../../dashboard-finance/service/admin-panel-filter.service";
import {AdxErpPanelFilterService} from "../../dashboard-finance/adx-erp-panel/service/adx-erp-panel-filter.service";
import {TmtErpPanelFilterService} from "../../dashboard-finance/tmt-erp-panel/service/tmt-erp-panel-filter.service";
import {ErpOutboundPanelFilterService} from "../../dashboard-finance/erp-outbound-panel/service/erp-outbound-panel-filter.service";
import {TmtErpOutboundPanelFilterService} from "../../dashboard-finance/tmt-erp-outbound-panel/service/tmt-erp-outbound-panel-filter.service";
import {AdxSbReconciliationFilterService} from "../../dashboard-finance/adx-sb-reconciliation/service/adx-sb-reconciliation-filter.service";
import {KtTripsFilterService} from "../../kt-trips/service/kt-trips-filter.service";

@AutoUnsubscribe()
@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    standalone: false
})
export class NavbarComponent implements OnInit, OnDestroy {
  public clients: Client[] = [];
  public agents: Agent[] = [];
  public positionOptions: TooltipPosition[] = ['left'];
  public position = new FormControl(this.positionOptions[0]);
  location: Location;
  mobile_menu_visible: any = 0;
  menuListItems!: MatMenuListItem[];
  isUserLoggedIn$: Observable<boolean>;
  private readonly _destroy = new Subject<void>();
  selectedMenu!: string;
  chartsPersonEmailFilter!: string | null;
  chartsFilterFromDate?: Date | null;
  isMenuItemsVisibleIfUserHasAnyRole: boolean = false;
  chartsFilterToDate?: Date | string | null;
  @Input() hideMenuToggle!: boolean;
  @Output() menuToggled = new EventEmitter();
  private appConstants: ApplicationConstants = new ApplicationConstants;
  private isInitialFilterModalOpenRequest: boolean = true;
  userAzureProfileDetails$: Observable<UserAzureProfileDetails | null | undefined>;
  public financeReportConfigResult: FinanceReportFilterResult = {};
  public VccDailySummaryReportConfigResult: VccDailySummaryReportFilterResult = {};
  public hideToggleFilterMenuIcon: boolean = true;
  public adxConfigResults: AdxVccFilter = {};
  public fmsVccFilterConfigResult: FmsVccFilterResult = {};
  public vccChartFilterConfigResult: VccChartFilterResult = {};
  public hsProcessingFilterConfigResult: HsProcessingFilter = {};
  public PaymentsReconciliationFilterConfigResult: PaymentReconciliationFilter = {};
  public glClosePeriodFilterConfigResult: ClosePeriodFilter = {};
  public braintreeMatchingVccFilterConfigResult: BraintreeMatchedVccFilter = {};
  public airMatchingReportFilterConfigResult: any = {};

  constructor(
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    private authService: MsalService,
    private azureAuthService: AzureAuthService,
    location: Location,
    private router: Router,
    private modal: ModalService,
    private filterService: FilterService,
    private clientService: ClientService,
    private agentService: AgentService,
    private date: DateService,
    private adxVccService: AdxVccService,
    private fmsVccService: FmsVccService,
    private chartsVccService: ChartsVccService,
    private hsProcessingService: HsProcessingService,
    private adxPaymentService: AdxPaymentService,
    private generalLedgerService: GeneralLedgerService,
    private braintreeMatchingVccService: BraintreeMatchingVccService,
    private airMatchingReportService: AirMatchingReportService,
    private navService: NavService,
    private readonly financeFilterModalService: FinanceFilterModalService,
    private readonly adminPanelFilterService: AdminPanelFilterService,
    private readonly adxErpPanelFilterService: AdxErpPanelFilterService,
    private readonly tmtErpPanelFilterService: TmtErpPanelFilterService,
    private readonly erpOutboundPanelFilterService: ErpOutboundPanelFilterService,
    private readonly tmtErpOutboundPanelFilterService: TmtErpOutboundPanelFilterService,
    private readonly adxSbReconciliationFilterService: AdxSbReconciliationFilterService,
    private readonly ktTripsFilterService: KtTripsFilterService,
  ) {
    this.chartsFilterFromDate = this.date.subtractDays(new Date(), 30);
    this.chartsFilterToDate = new Date();
    if(this.azureAuthService.checkUserAzureTokenHasAnyRole()){
      this.chartsVccService.getLatestDate().subscribe((latestReleasedDate) => {
        this.vccChartFilterConfigResult.releasedDateFrom = moment(latestReleasedDate).toDate();
      });
    }
    this.vccChartFilterConfigResult.releasedDateTo = this.chartsFilterToDate;
    this.location = location;
    this.menuListItems = [];
    this.userAzureProfileDetails$ = this.azureAuthService.getUserAuth$().pipe(map(ua => ua?.profile));
    this.isUserLoggedIn$ = this.azureAuthService.isUserLoggedIn.pipe(tap(isLoggedIn => this.setMenuListItems(isLoggedIn)));
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      const filterablePages = [
        'Transactions',
        'Vcc',
        'FinanceReports',
        'Vendors',
        'Clients',
        'Agents',
        'Services',
        'Invoices/TramsInvoices',
        'Invoices/FmsInvoices',
        'Invoices/AdxInvoiceLineItems',
        'Payments',
        'Balances',
        'FinanceResources',
        'TstResources',
        'FmsTrips',
        'FmsTramsTrips',
        'KtTrips',
        'GeneralLedger/ClosePeriod',
        'Dashboard/Finance',
        'Dashboard/AdminPanel',
        'Dashboard/AdxErpPanel',
        'Dashboard/TmtErpPanel',
        'Dashboard/ErpOutboundPanel',
        'Dashboard/TmtErpOutboundPanel',
        'Dashboard/AdxSbReconciliation',
      ];
      const link = this.router.url;
      this.hideToggleFilterMenuIcon = !filterablePages.some(item => {
        if (item === 'Invoices/TramsInvoices') {
          return link === '/Invoices/TramsInvoices';
        }
        if (link.startsWith('/FinanceResources/Alerts')) {
          return false;
        }
        if (link.includes('/Statements') && link.includes('?asOfDate')) {
          return false;
        }
        if (link.startsWith('/AdxPayments')) {
          return false;
        }
        if (link.includes('FinanceResources/MatchingVcc/') && link.match(/\/FinanceResources\/MatchingVcc\/\d+/)) {
          return false;
        }
        if (link.includes('FinanceResources/MatchingVccPaymentDetail/') && link.match(/\/FinanceResources\/MatchingVccPaymentDetail\/\d+/)) {
          return false;
        }
        if (link.startsWith('/FinanceResources/CommissionRules')) {
          return false;
        }
        return link.includes(item);
      });
    });
  }

  ngOnInit() {
    this.router.events.subscribe(() => {
      let $layer: any = document.getElementsByClassName('close-layer')[0];
      if ($layer) {
        $layer.remove();
        this.mobile_menu_visible = 0;
      }
    });
  }

  ngOnDestroy(): void {
    this._destroy.next(undefined);
    this._destroy.complete();
    localStorage.clear();
  }

  setMenuListItems(isLoggedIn: boolean) {
    if (!isLoggedIn || !this.azureAuthService.checkUserAzureTokenHasAnyRole()) {
      return;
    }
    this.isMenuItemsVisibleIfUserHasAnyRole = true;
    this.menuListItems = [
      {
        menuLinkId: 'vendors',
        menuLinkText: 'Vendors',
        menuIcon: 'face',
        isDisabled: false
      },
      {
        menuLinkId: 'clients',
        menuLinkText: 'Clients',
        menuIcon: 'face_4',
        isDisabled: false
      },
      {
        menuLinkId: 'agents',
        menuLinkText: 'Agents',
        menuIcon: 'face_2',
        isDisabled: false
      },
      {
        menuLinkId: 'services',
        menuLinkText: 'Services',
        menuIcon: 'list',
        isDisabled: false
      },
      {
        menuLinkId: 'actions',
        menuLinkText: 'Actions',
        menuIcon: 'create',
        isDisabled: false
      },
      {
        menuLinkId: 'templates',
        menuLinkText: 'Templates',
        menuIcon: 'map',
        isDisabled: false
      },
      {
        menuLinkId: 'nav-mappings',
        menuLinkText: 'NAV Mappings',
        menuIcon: 'book',
        isDisabled: false
      },
    ];
  }

  azureLogin() {
    if (this.msalGuardConfig.authRequest) {
      this.authService.loginRedirect({ ...this.msalGuardConfig.authRequest } as RedirectRequest)
    } else {
      this.authService.loginRedirect();
    }
  }

  azureLogout() {
    localStorage.clear();
    this.authService.logoutRedirect({ postLogoutRedirectUri: environment.postLogoutUrl });
  }

  clickMenuItem(menuItem: MatMenuListItem) {
    this.selectedMenu = menuItem.menuLinkText;

    if (menuItem.menuLinkText === 'Vendors') {
      this.router.navigate(['/Vendors']);
    }
    if (menuItem.menuLinkText === 'Clients') {
      this.router.navigate(['/Clients']);
    }
    if (menuItem.menuLinkText === 'Agents') {
      this.router.navigate(['/Agents']);
    }
    if (menuItem.menuLinkText === 'Actions') {
      this.router.navigate(['/RequestAction']);
    }
    if (menuItem.menuLinkText === 'Templates') {
      this.router.navigate(['/Templates']);
    }
    if (menuItem.menuLinkText === 'Services') {
      this.router.navigate(['/Services']);
    }
    if (menuItem.menuLinkText === 'NAV Mappings') {
      this.router.navigate(['/FileUpload']);
    }
  }

  openFilter() {
    const link = this.router.url;
    switch (true) {
      case link.includes('Transactions'):
        this.handleTransactionsFilter();
        break;

      case link.includes('/Dashboard/Vcc'):
        this.handleVccChartFilter();
        break;
      case link.includes('/Dashboard/Finance'):
        this.handleFinanceFilter();
        break;
      case link.includes('/Dashboard/AdminPanel'):
        this.handleAdminPanelFilter();
        break;
      case link.includes('/Dashboard/AdxErpPanel'):
        this.handleAdxErpPanelFilter();
        break;
      case link.includes('/Dashboard/TmtErpPanel'):
        this.handleTmtErpPanelFilter();
        break;
      case link.includes('/Dashboard/ErpOutboundPanel'):
        this.handleErpOutboundPanelFilter();
        break;
      case link.includes('/Dashboard/TmtErpOutboundPanel'):
        this.handleTmtErpOutboundPanelFilter();
        break;
      case link.includes('/Dashboard/AdxSbReconciliation'):
        this.handleAdxSbReconciliationFilter();
        break;

      case link.includes('/FinanceReports/TripProfitabilityWithAgency'):
        this.handleFinanceReportsFilter();
        break;

      case link.includes('/FinanceReports/TripProfitability'):
        this.handleFinanceReportsFilter();
        break;

      case link.includes('/FinanceReports/VccDailySummaryReport'):
        this.handleVccDailySummaryReportFilter();
        break;

      case link.includes('Vendors'):
        this.navService.openFilterButton();
        break;

      case link.includes('Clients') && link.includes('Statement') && !link.includes('asOfDate'):
        this.navService.openFilterButton();
        break;

      case link.includes('Clients') && !link.includes('Statement'):
        this.navService.openFilterButton();
        break;

      case link.includes('Agents'):
        this.navService.openFilterButton();
        break;

      case link.includes('Services'):
        this.navService.openFilterButton();
        break;

      case link.includes('Invoices/AdxInvoiceLineItems'):
        this.navService.openFilterButton();
        break;
      case link.includes('Invoices/TramsInvoices'):
        this.navService.openFilterButton();
        break;
      case link.includes('Invoices/FmsInvoices'):
        this.navService.openFilterButton();
        break;

      case link.includes('Balances/ClientBalance'):
        this.navService.openFilterButton();
        break;

      case link.includes('FinanceResources/AdxVcc'):
        this.handleAdxVccFilter();
        break;
      case link.includes('FinanceResources/FmsVcc'):
        this.handleFmsVccFilter();
        break;
      case link.includes('FinanceResources/MatchingVcc'):
        this.navService.openFilterButton();
        break;
      case link.includes('FinanceResources/ConnexpayVccMatchingReport'):
        this.navService.openFilterButton();
        break;
      case link.includes('FinanceResources/BraintreeVccMatchingReport'):
        this.handleBraintreeMatchingVccFilter();
        break;
      case link.includes('FinanceResources/MorAirMatchingReport'):
        this.handleMorAirMatchingReportFilter();
        break;
      case link.includes('TstResources/HsProcessing'):
        this.handleHsProcessingFilter();
        break;

      case link.includes('FmsTrips'):
        this.navService.openFilterButton();
        break;
      case link.includes('FmsTramsTrips'):
        this.navService.openFilterButton();
        break;
      case link.includes('KtTrips'):
        this.handleKtTripsFilter();
        break;
      case link.includes('Payments/Received'):
        this.navService.openFilterButton();
        break;
      case link.includes('Payments/Made'):
        this.navService.openFilterButton();
        break;
      case link.includes('Payments/PaymentsReconciliation'):
        this.handlePaymentsReconcilitionFilter();
        break;
      case link.includes('Payments/CommissionReconciliation'):
        this.navService.openFilterButton();
        break;
      case link.includes('GeneralLedger/ClosePeriod'):
        this.handleGlClosePeriodFilter();
        break;
      case link.includes('Balances/VendorBalance'):
        this.navService.openFilterButton();
        break;
    }
  }

  applyClientFilter(filter: ClientFilterResult): void {
    this.filterService.setClientFilter(filter);
  }

  loadClients(): void {
    const filters = this.filterService.getClientFilter();
    this.clientService.getClients(1, 25, filters).subscribe({
      next: (data: ClientData) => {
        this.clients = data.items;
      },
      error: (error: any) => {
        console.error('Error loading clients from navbar', error);
      }
    });
  }

  applyAgentFilter(filter: AgentFilterResult): void {
    this.filterService.setAgentFilter(filter);
  }

  loadAgents(): void {
    const filters = this.filterService.getAgentFilter();
    this.agentService.getAgents(1, 25, filters).subscribe({
      next: (data: AgentData) => {
        this.agents = data.items;
      },
      error: (error: any) => {
        console.error('Error loading agents from navbar', error);
      }
    });
  }

  private openGenericFilterModal(component: any, config: any, callback: (res: any) => void) {
    const filterRef = this.modal.open(component);
    const filterInstance = filterRef.componentInstance;
    filterInstance.config = config;
    filterRef.afterClosed().subscribe((result: any) => {
      if (result !== null) {
        callback(result);
      }
    });
  }

  private handleTransactionsFilter() {
    if (this.isInitialFilterModalOpenRequest && this.azureAuthService.checkUserAzureTokenHasDirectorRole()) {
      this.isInitialFilterModalOpenRequest = false;
      this.chartsPersonEmailFilter = this.appConstants.AllUser;
    }
    this.openGenericFilterModal(FilterModalComponent, {
      from: this.chartsFilterFromDate,
      to: this.chartsFilterToDate,
      email: this.chartsPersonEmailFilter
    }, (res: FilterResult | null) => {
      if (res) {
        this.chartsFilterFromDate = res.from;
        this.chartsFilterToDate = res.to;
        this.chartsPersonEmailFilter = res.email?.toString() ?? this.chartsPersonEmailFilter;
        this.filterService.setFilter(res);
      }
    });
  }

  private handleVccChartFilter() {
    this.openGenericFilterModal(VccChartFilterModalComponent, this.vccChartFilterConfigResult, (res: VccChartFilterResult | null) => {
      if (res) {
        this.vccChartFilterConfigResult = res;
        this.chartsVccService.setVccChartFilter(res);
      }
    });
  }

  private handleFinanceFilter() {
    this.financeFilterModalService.toggleModal.set(true);
  }

  private handleAdminPanelFilter() {
    this.adminPanelFilterService.toggleModal.set(true);
  }

  private handleAdxErpPanelFilter() {
    this.adxErpPanelFilterService.toggleModal.set(true);
  }

  private handleTmtErpPanelFilter() {
    this.tmtErpPanelFilterService.toggleModal.set(true);
  }

  private handleErpOutboundPanelFilter() {
    this.erpOutboundPanelFilterService.toggleModal.set(true);
  }

  private handleTmtErpOutboundPanelFilter() {
    this.tmtErpOutboundPanelFilterService.toggleModal.set(true);
  }

  private handleAdxSbReconciliationFilter() {
    this.adxSbReconciliationFilterService.toggleModal.set(true);
  }

  private handleKtTripsFilter() {
    this.ktTripsFilterService.toggleModal.set(true);
  }

  private handleVccDailySummaryReportFilter() {
    this.openGenericFilterModal(VccDailySummaryReportFilterModalComponent, this.VccDailySummaryReportConfigResult, (res: VccDailySummaryReportFilterResult | null) => {
      if (res) {
        this.VccDailySummaryReportConfigResult = res;
        this.filterService.setVccDailySummaryReportFilter(res);
      }
    });
  }

  private handleFinanceReportsFilter() {
    this.openGenericFilterModal(FinanceReportsFilterModalComponent, this.financeReportConfigResult, (res: FinanceReportFilterResult | null) => {
      if (res) {
        this.financeReportConfigResult = res;
        this.filterService.setFinanceReportFilter(res);
      }
    });
  }

  private handleAdxVccFilter() {
    this.openGenericFilterModal(AdxVccFilterComponent, this.adxConfigResults, (res: AdxVccFilter | null) => {
      if (res) {
        this.adxConfigResults = res;
        this.adxVccService.setAdxFilter(res);
      }
    });
  }

  private handleFmsVccFilter() {
    this.openGenericFilterModal(FmsVccFilterModalComponent, this.fmsVccFilterConfigResult, (res: FmsVccFilterResult | null) => {
      if (res) {
        this.fmsVccFilterConfigResult = res;
        this.fmsVccService.setFmsVccFilter(res);
      }
    });
  }

  private handleHsProcessingFilter() {
    this.hsProcessingService.getHsProcessingFilter().pipe(take(1)).subscribe((currentFilter: HsProcessingFilter | {}) => {
      const filterToUse = Object.keys(currentFilter as object).length > 0 ? currentFilter as HsProcessingFilter : this.hsProcessingFilterConfigResult;

      this.openGenericFilterModal(HsProcessingFilterComponent, filterToUse, (res: HsProcessingFilter | null) => {
        if (res) {
          this.hsProcessingFilterConfigResult = res;
          this.hsProcessingService.setHsProcessingFilter(res);
        }
      });
    });
  }

  private handlePaymentsReconcilitionFilter() {
    this.adxPaymentService.getPaymentsReconciliationFilter().pipe(take(1)).subscribe((currentFilter: PaymentReconciliationFilter | {}) => {
      const filterToUse = Object.keys(currentFilter as object).length > 0 ? currentFilter as PaymentReconciliationFilter : this.PaymentsReconciliationFilterConfigResult;

      this.openGenericFilterModal(PaymentReconciliationFilterComponent, filterToUse, (res: PaymentReconciliationFilter | null) => {
        if (res) {
          this.PaymentsReconciliationFilterConfigResult = res;
          this.adxPaymentService.setPaymentsReconciliationFilter(res);
        }
      });
    });
  }

  private handleGlClosePeriodFilter() {
    this.openGenericFilterModal(GlClosePeriodFilterComponent, this.glClosePeriodFilterConfigResult, (res: ClosePeriodFilter | null) => {
      if (res) {
        this.glClosePeriodFilterConfigResult = res;
        this.generalLedgerService.setGLClosePeriodFilter(res);
      }
    });
  }

  private handleBraintreeMatchingVccFilter() {
    this.openGenericFilterModal(BraintreeMatchingVccFilterComponent, this.braintreeMatchingVccFilterConfigResult, (res: BraintreeMatchedVccFilter | null) => {
      if (res) {
        this.braintreeMatchingVccFilterConfigResult = res;
        this.braintreeMatchingVccService.setBraintreeMatchingFilter(res);
      }
    });
  }

  private handleMorAirMatchingReportFilter() {
    this.airMatchingReportService.getAirMatchingFilter().pipe(take(1)).subscribe((currentFilter: any | {}) => {
      const filterToUse = Object.keys(currentFilter as object).length > 0 ? currentFilter : this.airMatchingReportFilterConfigResult;

      this.openGenericFilterModal(AirMatchingReportFilterComponent, filterToUse, (res: any | null) => {
        if (res) {
          this.airMatchingReportFilterConfigResult = res;
          this.airMatchingReportService.setAirMatchingFilter(res);
        }
      });
    });
  }
}
